import { colors, Icons } from '@flash-tecnologia/hros-web-ui-v2';
import { useSelectedCompany } from '@flash-tecnologia/hros-web-utility';
import { Typography } from '@mui/material';
import { useBffFetch } from 'api/getData';
import { withAdminPermission } from 'HOC/withAdminPermission';
import { withFeatureFlagEnabled } from 'HOC/withFeatureFlagEnabled';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

type FinancialStatus = { status: 'APPROVED' | 'DENIED' };

const Container = styled.div`
  width: 100%;
  height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  background: ${colors.feedback.error[90]};
  @media (max-width: 1250px) {
    padding: 0 14px;
    height: 70px;
  }
`;

const KycWarningBanner: FC = () => {
  const { selectedCompany } = useSelectedCompany();
  const [shouldRender, setShouldRender] = useState(false);
  const { fetchBff } = useBffFetch<undefined, FinancialStatus>({
    path: `/v1/companies/${selectedCompany.id}/financialstatus`,
    onSuccess: (data) => {
      if (data.status === 'APPROVED') {
        setShouldRender(false);
        return;
      }
      setShouldRender(true);
    },
  });

  useEffect(() => {
    fetchBff();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany]);

  return (
    shouldRender && (
      <Container>
        <div>
          <Icons
            name="IconAlertCircle"
            fill={colors.feedback.error[70]}
            color={colors.feedback.error[40]}
            size={24}
          />
        </div>

        <div style={{ width: '10px' }} />
        <Typography
          variant="body2"
          style={{ color: colors.feedback.error[10] }}
        >
          <b>Complete o cadastro da empresa! - </b>
          Acesse o quadro de tarefas e finalize a tarefa "Regularize sua empresa
          na plataforma"
        </Typography>
      </Container>
    )
  );
};

export default withFeatureFlagEnabled(
  withAdminPermission(KycWarningBanner),
  'FLASH_OS_ANTI_FRAUD_COMPANY_REGULATORY_INFORMATION_VIEW',
);
